import {pathFormat} from 'common/router/helper';

export default {
    computed: {
        path() {
            return pathFormat(this.item);
        },
        timestamp() {
            const pubTime = this.item.pubTime;
            if(pubTime) {
                return Date.parse(new Date(pubTime.replace(/-/g, '/')));
            }
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/mixin/news-item.js